import { State } from "../types/State";

export function initStateFromLocation() {
  return location.search
    .slice(1)
    .split("&")
    .filter((param) => param !== "")
    .reduce((acc, cur) => {
      const [k, v] = cur.split("=");
      if (k === "prix") {
        const price = v.split(",");
        acc["prix-min"] = price[0];
        acc["prix-max"] = price[1];
      }
      if (k === "surface") {
        acc["surface-min"] = v;
      } else if (k === "ville") {
        const ville = decodeURI(v).split(",");
        acc["code-postal"] = ville[0];
        acc["ville"] = ville[1];
        ville[2] && (acc["localite-range"] = ville[2]);
      } else {
        acc[k] = v.split(",");
      }
      return acc;
    }, {} as State);
}
